.root {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.help {
  margin-top: 2px;
}

.hidden-input {
  display: none;
}

.attachments {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
}

.attachment {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 6px;
  background: var(--color-muted-background, #f9fafb);
}

.attachment-thumb {
  height: 28px;
  width: 28px;
  flex-shrink: 0;
  border-radius: 4px;
  object-fit: cover;
}

.attachment-icon {
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  color: var(--color-muted, #6b7280);
}

.attachment-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachment-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--color-muted, #6b7280);
  border-radius: 4px;

  &:hover {
    color: var(--color-destructive, #ef4444);
  }
}
